import Component from '@glimmer/component'
import { colors } from '@colors'
import { SeriesColumn, type SeriesColumnOptions } from 'teacher-ui-client/components/giraffe/primitives/series-column'
import { t } from 'ember-intl'

export interface BooksReadByLevelData {
  range: string
  count: number
}

interface Args {
  data: BooksReadByLevelData[]
}

interface Signature {
  Element: HTMLDivElement
  Args: Args
}

export class DashboardBooksReadByLevel extends Component<Signature> {
  readonly color = [colors.purplyPink300]

  get categories() {
    return this.sortedBooksData.map((category) => category.range)
  }

  get chartData(): SeriesColumnOptions[] {
    const seriesData = this.sortedBooksData.map((book) => book.count)
    return [{ data: seriesData, type: 'column' as const }]
  }

  get sortedBooksData() {
    return (
      this.args.data.slice().sort((a, b) => {
        //compare the first number in each range
        const aRange = Number(a.range.split('-')[0])
        const bRange = Number(b.range.split('-')[0])
        return aRange - bRange
      }) ?? []
    )
  }

  <template>
    <div data-test-giraffe-dashboard-books-read-by-level class="flex h-full flex-col" ...attributes>
      <div class="relative grow">
        <div class="absolute inset-0">
          <SeriesColumn
            @data={{this.chartData}}
            @categories={{this.categories}}
            @colors={{this.color}}
            @dataLabelsEnabled={{true}}
            @xAxisLabel={{t "reporting.charts.dashboard.booksRead.byLevelLabel"}}
          />
        </div>
      </div>
    </div>
  </template>
}

export default DashboardBooksReadByLevel
